import { Box, Button } from '@mui/material'
import { Link } from 'react-router-dom'
import { useAdmin } from 'contexts/AdminProvider'
import React from 'react'
import Header from 'components/Header'
import { GridRowParams } from '@mui/x-data-grid'
import { useNavigate } from 'react-router'
import { adminJobDetailURL, adminPostPrematchedJobsURL } from 'routes/urls'
import Job from 'logic/Job'
import AdminJobTable from 'components/AdminJobTable'

const AdminJobList: React.FC = () => {
  const navigate = useNavigate()
  const { 
    jobSearchForm,
    jobSelection,
    jobColumnVisibilityModel,
    jobSortModel,
    updateJobSearchForm,
    setJobSelection,
    setJobColumnVisibilityModel,
    setJobSortModel,
  } = useAdmin()

  const onRowClick = React.useCallback((params: GridRowParams<Job>) => {
    navigate(adminJobDetailURL(params.row.job_id))
  }, [navigate])

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, height: '100%' }}>
      <Header text='Jobs List'>
        <Button component={Link} variant='contained' color='primary' to={adminPostPrematchedJobsURL()}>
          Create Pre-Matched Job
        </Button>
      </Header>
      <AdminJobTable
        onRowClick={onRowClick}
        form={jobSearchForm}
        updateForm={updateJobSearchForm}
        selection={jobSelection}
        setSelection={setJobSelection}
        columnVisibilityModel={jobColumnVisibilityModel}
        setColumnVisibilityModel={setJobColumnVisibilityModel}
        sortModel={jobSortModel}
        setSortModel={setJobSortModel}
      />
    </Box>
  )
}

export default AdminJobList